// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-border[data-v-0002b833]{margin:12px auto;border-top:2px solid #e6e6e6;width:95%}.divider-line[data-v-0002b833]{border-left:1px solid #b9b9b9;height:100px;margin:0 12px}.d-grid[data-v-0002b833]{display:grid}.grid-cols-2[data-v-0002b833]{grid-template-columns:1fr 1fr;grid-template-rows:-webkit-min-content;grid-template-rows:min-content}", ""]);
// Exports
module.exports = exports;
